export class Diff<TItem>
{
    private before: TItem[];
    private after: TItem[];
    private getId: (item: TItem) => string;
    private areEqual: (itemA: TItem, itemB: TItem) => boolean;

    constructor(before: TItem[], after: TItem[], getId: (item: TItem) => string, areEqual: (itemA: TItem, itemB: TItem) => boolean)
    {
        this.before = before;
        this.after = after;
        this.getId = getId;
        this.areEqual = areEqual;
    }

    public execute(): IDiffResult<TItem>
    {
        const beforeMap = new Map(this.before.map(i => [this.getId(i), i]));
        const afterMap = new Map(this.after.map(i => [this.getId(i), i]));

        const createdItems = this.after.filter(i => !beforeMap.has(this.getId(i)));
        const deletedItems = this.before.filter(i => !afterMap.has(this.getId(i)));
        
        const updatedItems = this.before
            .filter(before => afterMap.has(this.getId(before)) && !this.areEqual(before, afterMap.get(this.getId(before))!))
            .map(before => ({ before, after: afterMap.get(this.getId(before))! }));

        const isDirty = (createdItems.length > 0 || deletedItems.length > 0 || updatedItems.length > 0);

        return {
            createdItems,
            deletedItems,
            updatedItems,
            isDirty,
        };
    }
}

export interface IDiffResult<TItem>
{
    createdItems: TItem[];
    deletedItems: TItem[];
    updatedItems: IUpdatedItem<TItem>[];
    isDirty: boolean;
}

export interface IUpdatedItem<TItem>
{
    before: TItem;
    after: TItem;
}
